'use strict';

/* global yith_wcaf */

import { block, unblock } from '../../../src/globals.js';
import YITH_WCAF_Admin_Tabbed_Modal from './yith-wcaf-admin-tabbed-modal';
import YITH_WCAF_Ajax from '../../../src/modules/ajax.js';

export default class YITH_WCAF_Add_Affiliate_Modal extends YITH_WCAF_Admin_Tabbed_Modal {
	constructor( $opener ) {
		super( $opener, {
			template: 'yith-wcaf-add-affiliate-modal',
			titleTemplate: 'yith-wcaf-add-affiliate-modal-title',
			data: {},
			width: 400,
		} );
	}

	initPswForm() {
		const $wrapper = this.modal.elements.wrap,
			$generatePswButton = $wrapper.find( '.wp-generate-pw' ),
			$pswForm = $wrapper.find( '.wp-pwd' ),
			$pswField = $pswForm.find( '#password' ),
			$cancelButton = $pswForm.find( '.wp-cancel-pw' ),
			$customPswField = $pswForm.find( '#use_custom_password' );

		$generatePswButton.on( 'click', () => {
			if ( ! $pswForm.is( ':visible' ) ) {
				$pswForm.addClass( 'is-open' );
				$customPswField.val( 1 );
				this.onPswToggle( true );
			} else {
				block( $generatePswButton );

				wp.ajax.post( 'generate-password' ).done( ( data ) => {
					$pswField.val( data );
					this.onPswToggle( true );
					unblock( $generatePswButton );
				} );
			}
		} );

		$cancelButton.on( 'click', () => {
			$pswForm.removeClass( 'is-open' );
			$customPswField.val( 0 );
		} );
	}

	initPswToggles() {
		const $wrapper = this.modal.elements.wrap,
			$pswForm = $wrapper.find( '.wp-pwd' ),
			$toggleButtons = $pswForm.find( '.wp-toggle-pw' );

		$toggleButtons.on( 'click', this.onPswToggle.bind( this ) );

		this.onPswToggle( true );
	}

	onOpen() {
		super.onOpen();

		this.initPswForm();
		this.initPswToggles();
	}

	onPswToggle( show ) {
		const $wrapper = this.modal.elements.wrap,
			$pswForm = $wrapper.find( '.wp-pwd' ),
			$pswField = $pswForm.find( '#password' ),
			$toggleButtons = $pswForm.find( '.wp-toggle-pw' ),
			toggle =
				'boolean' === typeof show
					? show
					: 'password' === $pswField.attr( 'type' );

		if ( toggle ) {
			$pswField.attr( 'type', 'text' );
			$toggleButtons.filter( '.wp-hide-pw' ).show();
			$toggleButtons.filter( '.wp-show-pw' ).hide();
		} else {
			$pswField.attr( 'type', 'password' );
			$toggleButtons.filter( '.wp-show-pw' ).show();
			$toggleButtons.filter( '.wp-hide-pw' ).hide();
		}
	}

	onSubmit() {
		const $content = this.modal.elements.content;

		if ( ! this.beforeSubmit() ) {
			return false;
		}

		this.hideErrorMessage();

		const affiliate = this.serialize();

		YITH_WCAF_Ajax.post
			.call( $content, 'create_affiliate', 'create_affiliate', affiliate )
			.done( ( data ) => {
				if ( 'function' === typeof this.args?.onSubmitSuccess ) {
					this.args?.onSubmitSuccess( data?.data );
				}

				if ( data?.success ) {
					window.location.reload();
				} else if ( data?.data?.message ) {
					this.showErrorMessage( data.data.message );
				}
			} );

		return false;
	}
}
